import { useTranslation } from 'react-i18next';

/** Contenu du toast succès « passage en direct confirmé », rendu via react-toastify (toast.success). */
export default function LiveConfirmedToast() {
  const { t } = useTranslation('common');
  return (
    <div>
      <p className="font-semibold">{t('liveSettings.liveConfirmed.title')}</p>
      <p className="text-sm opacity-80">{t('liveSettings.liveConfirmed.body')}</p>
    </div>
  );
}
